import { Injectable, ApplicationRef } from '@angular/core';
import { RouterPreloader } from '@angular/router';
import { first, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModulePreloadService {
  private started = false;

  constructor(private appRef: ApplicationRef, private preloader: RouterPreloader) {}

  /**
   * Start preloading all lazy-loaded modules once the application is stable
   * to cache them for offline use without blocking the initial load.
   */
  startPreloading(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    const preload = () => this.preloader.preload().subscribe();

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      (window as any).requestIdleCallback(preload);
    } else {
      this.appRef.isStable.pipe(first(isStable => isStable)).subscribe(() => {
        timer(5000).subscribe(preload);
      });
    }
  }
}
